import { WorkOSUser } from '@/components/UserProfileSettingDetail'
import { trpc } from '@/utils/trpc'
import { useNavigate } from '@tanstack/react-router'
import { useLocalStorage } from 'usehooks-ts'

export default function useLogout() {
  const { mutateAsync: logoutUser, isPending: loggingOut } = trpc.logoutUser.useMutation()

  const navigate = useNavigate()
  const [, setUser] = useLocalStorage<WorkOSUser | undefined>('_wos_user', undefined)

  function logout(routeToLogin: boolean = true) {
    logoutUser().then(() => {
      setUser(undefined)
      localStorage.clear()
      navigator?.serviceWorker?.getRegistrations().then((registrations) => {
        return Promise.all(
          registrations.map((registration) => {
            return registration.unregister()
          }),
        )
      })
      caches?.keys().then((keyList) => {
        return Promise.all(
          keyList.map((key) => {
            return caches.delete(key)
          }),
        )
      })
      if (routeToLogin)
        setTimeout(() => {
          navigate({ to: '/login' })
        }, 200)
    })
  }

  return {
    logout,
    loggingOut,
  }
}
